import script from "./UploadComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadComponent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__